import { Component,  OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from '@shared/services/shared.service';
import { IAdministrativeComplaintView } from 'app/models/mainMenu/mainMenu';
import { IComplaintSearchViewModel } from 'app/models/search/search';
import { ISelectItems } from 'app/models/shared/shared';
import { BusinessService } from 'app/services/business/business.service';
import { ComplaintService } from 'app/services/complaint/complaint.service';
import { ProcessComplaintService } from 'app/services/complaint/processComplaint.service';
import { SearchService } from 'app/services/search/search.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})

export class SearchComponent implements OnInit {

  countySelected:string = '';
  countyList: ISelectItems[] = [];
  showList: boolean = false;
  searchList: IAdministrativeComplaintView[] = [];
  resultsCount: number = 0;
  searchParameters: IComplaintSearchViewModel;
  filter: string = '';

  displayedColumns: string[] = ['complaintId', 'businessName', 'address', 'city', 'zip', 
      'complaintDate', 'reasonNonActionable', 'complaintStatus'];
  dataSource = new MatTableDataSource<IAdministrativeComplaintView>(this.searchList);

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(public searchService: SearchService,
    public processComplaintService: ProcessComplaintService,
    public sharedService: SharedService,
    private complaintService: ComplaintService,
    private businessService: BusinessService
  ) { }

  form = new UntypedFormGroup({
    searchText: new UntypedFormControl('',[Validators.maxLength(50)]),
    countyId: new UntypedFormControl('All'),
    startDate: new UntypedFormControl(''),
    endDate: new UntypedFormControl('')
  });
  
  ngOnInit(): void {
    this.showList = false;
    this.countyList = this.sharedService.userCountyList;
    // this.form.controls['countyId'].setValue('All');
  }

  getSearchData(){
    let formParam = this.form.value;
    let searchParam: IComplaintSearchViewModel =
    {
      complaintId: 0,
      countyId: formParam.countyId,
      status: "",
      filter: formParam.searchText,
      startDate: formParam.startDate,
      endDate: formParam.endDate
    };

    this.searchService.getSearchData(searchParam).subscribe({
      next: response => {
        this.searchList = response;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        if (response != null){
          this.resultsCount = response.length;
          this.dataSource.data = this.searchList;
        }
        this.showList = true;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get search data.");
        this.resultsCount = 0;
      },
    });
  }

  gotoBusiness(businessId: string) {
    this.businessService.businessId = +businessId;
    this.businessService.businessTab = 0;
    this.sharedService.doRedirect('business/business');
  }

  gotoComplaint(complaintId: string) {
    this.complaintService.complaintId = +complaintId;
    this.complaintService.complaintTab = 0;
    this.sharedService.doRedirect('complaint/complaint/'+complaintId);
  }

  gotoUnverified(complaintId: string, businessId: string) {
    this.processComplaintService.complaintId = +complaintId;
    if (businessId == null || (+businessId == 0)) {
      this.sharedService.doRedirect('/complaint/processComplaint');
    }
    else {
      this.sharedService.doRedirect('/complaint/determineComplaint');
    }
  }

  filterTable(event: Event) {
    this.dataSource.filter = (event.target as HTMLInputElement).value.trim().toLocaleLowerCase();
    this.filter = this.dataSource.filter;
  }

  download() {
    let csvFile = '"Complaint ID","Business Name","Address","City","Zip","Complaint Date","Reason Non-Actionable","Complaint Status"' + '\n';
    this.searchList.forEach(x=> {
      let line = '"' + x.complaintId + '","' + x.businessName + '","' + x.address + '","' + x.city + '","' + x.zip 
          + '","' + x.complaintDate + '","' + x.reasonNonActionable + '","' + x.complaintStatus + '"'; 
      csvFile += line + '\n';
    });
    this.sharedService.downloadCSV(csvFile,'BusinessReport.csv');
  }
}
